import CampaignsGateway from './CampaignsGateway'
import CampaignModel from './CampaignModel'
import TagsListModel from './TagsListModel'
import EmailsModel from './EmailsModel'
import UnassignedEmailsModel from './UnassignedEmailsModel'

// TODO: should not exclude random names of campaigns
const excludeCampaigns = ['Orange Test 2', 'Orange Test', 'Campaign', 'Orange Test']

export default class CampaignsService {
  constructor (campaignsGateway) {
    this.CampaignsGateway = campaignsGateway || new CampaignsGateway()

    this.getCampaignStatistics = this.getCampaignStatistics.bind(this)
    this.getCurrentCampaign = this.getCurrentCampaign.bind(this)
    this.getActiveCampaign = this.getActiveCampaign.bind(this)
    this.resetCampaignCode = this.resetCampaignCode.bind(this)
    this.deleteCampaignCode = this.deleteCampaignCode.bind(this)
    this.resetManyCampaignCodes = this.resetManyCampaignCodes.bind(this)
    this.deleteManyCampaignCodes = this.deleteManyCampaignCodes.bind(this)
    this.sendEmailsCampaign = this.sendEmailsCampaign.bind(this)
    this.closeCurrentCampaign = this.closeCurrentCampaign.bind(this)
    this.createCampaign = this.createCampaign.bind(this)
    this.getCurrentEmailTemplate = this.getCurrentEmailTemplate.bind(this)
    this.updateCurrentEmailTemplate = this.updateCurrentEmailTemplate.bind(this)
    this.getCampaignIndividualEmails = this.getCampaignIndividualEmails.bind(this)
    this.getCampaignBulkEmails = this.getCampaignBulkEmails.bind(this)
    this.getCampaignActiveId = this.getCampaignActiveId.bind(this)
    this.getCampaignList = this.getCampaignList.bind(this)
    this.getCampaignUnassignedEmails = this.getCampaignUnassignedEmails.bind(this)
    this.campaignAddEmail = this.campaignAddEmail.bind(this)
    this.createEmailTemplate = this.createEmailTemplate.bind(this)
    this.getEmailTemplates = this.getEmailTemplates.bind(this)
    this.getEmailTemplate = this.getEmailTemplate.bind(this)
    this.deleteEmailTemplate = this.deleteEmailTemplate.bind(this)
    this.changeCampaignValidity = this.changeCampaignValidity.bind(this)
    this.getAllCampaignList = this.getAllCampaignList.bind(this)
    this.getCampaignStatus = this.getCampaignStatus.bind(this)
    this.setCampaignDisabledFlag = this.setCampaignDisabledFlag.bind(this)
  }

  setCampaignDisabledFlag (query) {
    return this.CampaignsGateway
    .setCampaignDisabledFlag(query)
    .then(response => response)
  }

  getCampaignStatus (query) {
    return this.CampaignsGateway
    .getCampaignStatus(query)
    .then(response => response)
  }

  getAllCampaignList (query) {
    return this.CampaignsGateway
    .getAllCampaignList(query)
    .then(response => response.map(item => ({
      ...item,
      key: item.id
    })))
  }

  changeCampaignValidity (query) {
    return this.CampaignsGateway
    .changeCampaignValidity(query)
    .then(response => response)
  }

  campaignAddEmail (query) {
    return this.CampaignsGateway
    .campaignAddEmail(query)
    .then(response => response)
  }

  getCampaignUnassignedEmails () {
    return this.CampaignsGateway
    .getCampaignUnassignedEmails()
    .then(response => response.map(item => UnassignedEmailsModel(item)))
  }

  getCampaignList () {
    return this.CampaignsGateway
    .getCampaignList()
    .then(response => response.filter(item => excludeCampaigns.indexOf(item.name) === -1))
  }

  getCampaignActiveId () {
    return this.CampaignsGateway
    .getCampaignActiveId()
    .then(response => response)
  }

  getEmailTemplates () {
    return this.CampaignsGateway
    .getEmailTemplates()
    .then(response => response.map(item => ({
      ...item,
      value: item.name || item.subject
    }))
    )
  }

  getEmailTemplate (params) {
    return this.CampaignsGateway
    .getEmailTemplate(params)
    .then(response => response)
  }

  createEmailTemplate (query) {
    return this.CampaignsGateway
      .createEmailTemplate(query)
      .then(response => response)
  }

  deleteEmailTemplate (query) {
    return this.CampaignsGateway
      .deleteEmailTemplate(query)
      .then(response => response)
  }

  getCampaignBulkEmails (params) {
    return this.CampaignsGateway
    .getCampaignBulkEmails(params)
    .then(response => response.map(item => EmailsModel(item[0])))
  }

  getCampaignIndividualEmails (params) {
    return this.CampaignsGateway
    .getCampaignIndividualEmails(params)
    .then(response => response.map(item => EmailsModel(item[0])))
  }

  updateCurrentEmailTemplate (params) {
    return this.CampaignsGateway
    .updateCurrentEmailTemplate(params)
    .then(response => response)
  }

  getCurrentEmailTemplate (params) {
    return this.CampaignsGateway
    .getCurrentEmailTemplate(params)
    .then(response => response)
  }

  getCampaignStatistics (params) {
    return this.CampaignsGateway
    .getCampaignStatistics(params)
    .then(response => new TagsListModel(response))
  }

  getCurrentCampaign (params) {
    return this.CampaignsGateway
    .getCurrentCampaign(params)
    .then(response => new CampaignModel(response))
  }

  sendEmailsCampaign (query) {
    return this.CampaignsGateway
      .sendEmailsCampaign(query)
      .then(response => response)
  }

  closeCurrentCampaign (query) {
    return this.CampaignsGateway
      .closeCurrentCampaign(query)
      .then(response => response)
  }

  resetCampaignCode (query) {
    return this.CampaignsGateway
      .resetCampaignCode(query)
      .then(response => response)
  }

  resetManyCampaignCodes (query) {
    return this.CampaignsGateway
      .resetManyCampaignCodes(query)
      .then(response => response)
  }

  getActiveCampaign () {
    return this.CampaignsGateway
      .getActiveCampaign()
      .then(response => response)
  }

  deleteCampaignCode (query) {
    return this.CampaignsGateway
      .deleteCampaignCode(query)
      .then(response => response)
  }

  deleteManyCampaignCodes (query) {
    return this.CampaignsGateway
      .deleteManyCampaignCodes(query)
      .then(response => response)
  }

  createCampaign (query) {
    return this.CampaignsGateway
      .createCampaign(query)
      .then(() => ({ status: 'Success' }))
  }
}



// WEBPACK FOOTER //
// ./src/api/campaigns/CampaignsService.js